import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullhorn, faUserGroup } from "@fortawesome/free-solid-svg-icons";
import { faDriversLicense } from "@fortawesome/free-regular-svg-icons";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";

const AddTeamBody = ({ register, errors, unregister }) => {
	const [teamValue, setTeamValue] = useState("team");

	const handleChange = (event, newValue) => {
		setTeamValue(newValue);
		unregister(["phone", "recipentMail"]);
	};

	const [hiddenAlerts, setHiddenAlerts] = useState([]);
	const onClose = (alertId) => {
		const hiddenAlertsUpdated = [...hiddenAlerts, alertId];
		setHiddenAlerts(hiddenAlertsUpdated);
	};

	const shouldShowAlert = (alertId) => hiddenAlerts.indexOf(alertId) === -1;

	return (
		<div>
			<p>
				Invite your teammates by adding their emails.For inviting driver, keep exactly same number
				as asset contact number.
			</p>
			<Box sx={{ width: "100%", typography: "body1" }}>
				<TabContext value={teamValue}>
					<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
						<TabList
							onChange={handleChange}
							aria-label="lab API tabs example"
							variant="fullWidth"
							indicatorColor="primary"
							textColor="primary"
						>
							<Tab
								label={
									<div>
										<FontAwesomeIcon icon={faUserGroup} className="me-2" /> Invite Members
									</div>
								}
								value="team"
							/>
							<Tab
								label={
									<div>
										<FontAwesomeIcon icon={faDriversLicense} className="me-2" /> Invite Drivers
									</div>
								}
								value="drivers"
							/>
						</TabList>
					</Box>
					<TabPanel value="team" className="py-4">
						<TextField
							fullWidth
							label="Invite Members via email"
							variant="outlined"
							type="email"
							{...register("recipentMail", { required: true })}
							name="recipentMail"
							placeholder="name@example.com"
							sx={{ marginBottom: "10px" }}
						/>
					</TabPanel>
					{teamValue === "drivers" && (
						<TabPanel value="drivers" className="py-4">
							<Alert
								variant="outlined"
								severity="info"
								open={shouldShowAlert("secondary")}
								onClose={() => onClose("secondary")}
								action={
									<IconButton
										aria-label="close"
										color="inherit"
										size="small"
										onClick={() => onClose("secondary")}
									>
										<CloseIcon fontSize="inherit" />
									</IconButton>
								}
							>
								<div style={{ display: "flex", justifyContent: "space-between" }}>
									<div>
										<FontAwesomeIcon style={{ marginRight: "10px" }} icon={faBullhorn} />
										<strong>New!</strong> Invited drivers can sign up via mobile apps.
									</div>
								</div>
							</Alert>
							<TextField
								fullWidth
								label="Email"
								variant="outlined"
								type="email"
								{...register("recipentMail", { required: true })}
								name="recipentMail"
								placeholder="name@example.com"
								sx={{ marginBottom: "10px", marginTop: "10px" }}
							/>
							<TextField
								fullWidth
								label="Phone"
								variant="outlined"
								type="text"
								{...register("phone", {
									required: "Valid phone number needed same as asset contact number",
								})}
								name="phone"
								placeholder="Enter phone number"
								error={Boolean(errors.phone)}
								helperText={
									errors.phone ? errors.phone.message : "Put same as from the asset contact number"
								}
								sx={{ marginBottom: "10px" }}
							/>
						</TabPanel>
					)}
				</TabContext>
			</Box>
		</div>
	);
};

export default AddTeamBody;
